export default "__VITE_ASSET__86f17127__"